import { render } from "./c-loader.vue?vue&type=template&id=208f858c&scoped=true"
const script = {}

import "./c-loader.vue?vue&type=style&index=0&id=208f858c&lang=scss&scoped=true"

import exportComponent from "/builds/secur/secur-v2-cloud/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-208f858c"]])

export default __exports__